export const isDev: boolean = (() => {
  const searchParams = new URLSearchParams(location.search);
  const locationDev = searchParams.get("_env");
  const hostName = location.hostname;
  // hostName.includes("172") ||

  // return false; // TODO remove

  if (locationDev === "prod") {
    return false;
  }

  if (
    hostName.includes("127.0.0.1") ||
    hostName.includes("172.26.1.16") ||
    hostName.includes("localhost") ||
    hostName.includes("local") ||
    hostName.includes("dev")
  ) {
    return true;
  } else {
    return false;
  }
})();

export const isProd = !isDev;

export const isLinjieApp = () => {
  const ua = navigator.userAgent.toLowerCase();
  // 老版本 App UA 含 linjie；新版本（千岛/kuril）含 kuril-ios / kuril-android
  return ua.includes("linjie") || ua.includes("kuril");
};

export const isInWechatWebview = () => {
  if (typeof window === "undefined" || !window.navigator) {
    return false;
  }

  return /micromessenger/i.test(window.navigator.userAgent);
};
